import { lazy } from 'react'

export const GoodHandsV1 = lazy(() => import('./v1/GoodHandsV1'))
export const GoodHandsV2 = lazy(() => import('./v2/GoodHandsV2'))
